import { NextLink } from '@/atoms';
import { Button as ButtonMolecule } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeButtonProps } from './types';

export const Button: FunctionComponent<TypeButtonProps> = ({
  className,
  style = 'tertiary',
  disabled = false,
  size = 'normal',
  negative = false,
  icon = null,
  label,
  href,
  ...props
}: TypeButtonProps): JSX.Element => (
  <NextLink href={href} passHref>
    <ButtonMolecule
      as="a"
      {...(className && { className })}
      style={style}
      disabled={disabled}
      size={size}
      negative={negative}
      icon={icon}
      label={label}
      {...props}
    />
  </NextLink>
);
